// import { onMounted, onBeforeUnmount } from 'vue'
// import { useMusic } from './useMusic'

export function useMusicOnMount(name: string) {
  const { playMusic, stopMusic } = useMusic()

  onMounted(() => {
    playMusic(name)
  })

  onBeforeUnmount(() => {
    stopMusic()
  })
}
